export default function sortNftsByDeposited<T extends { isDeposited: boolean }>(
  nfts: T[]
): T[] {
  return nfts.sort((a, b) => Number(b.isDeposited) - Number(a.isDeposited));
}
